import { z } from 'zod'

export const ApiSuccessEnvelopeSchema = z.object({
  ok: z.literal(true),
  request_id: z.string(),
  data: z.unknown(),
})

export const ApiErrorDetailSchema = z.object({
  field: z.string(),
  code: z.string(),
  message: z.string(),
})

export const ApiErrorEnvelopeSchema = z.object({
  ok: z.literal(false),
  request_id: z.string(),
  error: z.object({
    code: z.string(),
    message: z.string(),
    retryable: z.boolean(),
    details: z.array(ApiErrorDetailSchema).optional(),
  }),
})


const ActiveRulesSchema = z.object({
  version: z.string().trim().min(1).max(80),
  rulesHash: z.string().trim().min(1).max(160),
  url: z.string().url(),
})
export const PublicConfigSchema = z.object({
  launchState: z.enum(['prelaunch', 'live', 'paused']),
  commerceAvailable: z.boolean(),
  priceVisible: z.boolean(),
  giveawayAvailable: z.boolean(),
  version: z.string(),
  activeRules: ActiveRulesSchema.nullable(),
  cache: z.object({
    maxAgeSeconds: z.number().int().min(0).max(60),
    purgeAt: z.string().datetime().nullable(),
  }),
  featureHints: z.object({
    posthogMayExperiment: z.boolean(),
    publicConfigAuthority: z.literal('railway-postgresql'),
  }),
  contentSwitches: z.record(z.string(), z.boolean()),
})

export type PublicConfig = z.infer<typeof PublicConfigSchema>

export interface ApiSuccess<T extends object> {
  readonly ok: true
  readonly request_id: string
  readonly data: T
}
